export enum ChargerProducts {
    Halo1 = 1,
    Halo2 = 3,
    Aura = 4,
    Dawn = 7,
    Luna = 9,
    Aura2 = 10,
}

export type ChargerProductDefinition = {
    modelName: string
    brandedName: string
    translationKey: string
}

export const chargerProductDefinitions: Record<ChargerProducts, ChargerProductDefinition> = {
    [ChargerProducts.Halo1]: {
        modelName: 'Halo1',
        brandedName: 'Charge Amps Halo',
        translationKey: 'lblHaloControlWidget',
    },
    [ChargerProducts.Halo2]: {
        modelName: 'Halo2',
        brandedName: 'Charge Amps Halo',
        translationKey: 'lblHaloControlWidget',
    },
    [ChargerProducts.Aura]: {
        modelName: 'Aura',
        brandedName: 'Charge Amps Aura',
        translationKey: 'lblAuraControl',
    },
    [ChargerProducts.Dawn]: {
        modelName: 'Dawn',
        brandedName: 'Charge Amps Dawn',
        translationKey: 'lblDawnControlOcppWidget',
    },
    [ChargerProducts.Luna]: {
        modelName: 'Luna',
        brandedName: 'Charge Amps Luna',
        translationKey: 'lblLunaControlOcppWidget',
    },
    [ChargerProducts.Aura2]: {
        modelName: 'Aura 2',
        brandedName: 'Charge Amps Aura 2',
        translationKey: 'lblAura2Control',
    },
}

export const getChargerProductDefinition = (
    productId?: string | number | null
): ChargerProductDefinition | undefined => {
    if (productId == null) return undefined

    return chargerProductDefinitions[Number(productId) as ChargerProducts]
}

export const getChargerProductModelName = (productId?: string | number | null, fallbackName = ''): string =>
    getChargerProductDefinition(productId)?.modelName ?? fallbackName

export enum MeasurementDeviceProducts {
    AmpGuard = 5,
    Enegic = 6,
    AmpGuard2 = 8,
}

export enum MiscProducts {
    Ray = 2,
}

export const Products = { ...ChargerProducts, ...MeasurementDeviceProducts, ...MiscProducts }
